import React, { useContext } from 'react';
import { ReactComponent as CloseIcon } from '@/assets/close.svg';
import { submitContext } from '../../../contexts/submit.context';

export const CancelPreview = () => {
	const { setMessage } = useContext(submitContext);
	return (
		<button
			type="button"
			className="form__cancel"
			onClick={() => setMessage(undefined)}
		>
			<CloseIcon className="icon cancel" />
		</button>
	);
};
